import {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from 'react'
import { createMarkup } from '../../models/Common'
import DOMConditional from '../common/DOMConditional'

export interface IGetHelpOptionContentProps {
  content: string
}

const GetHelpOptionContent = forwardRef(
  (props: IGetHelpOptionContentProps, ref) => {
    const mountedRef = useRef(false)
    const [content, setContent] = useState('')
    const [visible, setVisible] = useState(false)

    useImperativeHandle(ref, () => ({
      clear() {
        setVisible(!visible)
      },
    }))

    useEffect(() => {
      mountedRef.current = true
      if (mountedRef.current) {
        setContent(props.content)
      }
      return () => {
        mountedRef.current = false
      }
    }, [])

    //The replacement in this method is a temporary solution. Once DB is updated, it should be reverted.
    const createReplaceMarkup = (content: string) => {
      if (content === null || content === undefined) {
        return createMarkup(content)
      }

      content = content.replaceAll(
        '/images/UserUploadedImages/151/open-new-tab-icon.png',
        '/public/open-new-tab-icon.png'
      )
      return createMarkup(content)
    }

    return (
      <DOMConditional show={visible}>
        <div className="highlight blue">
          <p dangerouslySetInnerHTML={createReplaceMarkup(content)}></p>
        </div>
      </DOMConditional>
    )
  }
)

GetHelpOptionContent.displayName = 'GetHelpOptionContent'
export default GetHelpOptionContent
